import { MERCHANT_VERIFICATION_STEP_PATHS } from '@/constants';
import VerificationInfo from '@/containers/MerchantVerification/VerificationInfo';
import { shouldCollectDocuments } from '@/selectors/documentUpload';
import VerificationSuccess from '@/containers/MerchantVerification/VerificationSuccess';
import VerificationOverview from '@/containers/MerchantVerification/VerificationOverview';
import VerificationDataCollection from '@/containers/MerchantVerification/VerificationDataCollection';

export const defaultMerchantVerificationFlow = options => {
  return {
    stepNotFoundPath: MERCHANT_VERIFICATION_STEP_PATHS.VERIFICATION_INFO,
    globalPrerequisites: [],
    selectors: {
      shouldCollectDocuments,
    },
    neededCaps: {},
    steps: [
      {
        id: 'verification-info',
        path: MERCHANT_VERIFICATION_STEP_PATHS.VERIFICATION_INFO,
        Container: VerificationInfo,
        back: false,
        next: MERCHANT_VERIFICATION_STEP_PATHS.VERIFICATION_OVERVIEW,
      },
      {
        id: 'verification-overview',
        path: MERCHANT_VERIFICATION_STEP_PATHS.VERIFICATION_OVERVIEW,
        Container: VerificationOverview,
        back: MERCHANT_VERIFICATION_STEP_PATHS.VERIFICATION_INFO,
        next: MERCHANT_VERIFICATION_STEP_PATHS.VERIFICATION_DATA_COLLECTION,
      },
      {
        id: 'verify-data',
        path: MERCHANT_VERIFICATION_STEP_PATHS.VERIFICATION_DATA_COLLECTION,
        Container: VerificationDataCollection,
        back: MERCHANT_VERIFICATION_STEP_PATHS.VERIFICATION_OVERVIEW,
        next: MERCHANT_VERIFICATION_STEP_PATHS.VERIFICATION_SUCCESS_PATH,
      },
      {
        id: 'success',
        path: MERCHANT_VERIFICATION_STEP_PATHS.VERIFICATION_SUCCESS_PATH,
        Container: VerificationSuccess,
        back: false,
        next: false,
      },
    ],
  };
};
